export class NumberEncodingService {
    private static readonly SECRET = 0xabcdef;

    public static encode(number: number): string {
        const salted = number ^ this.SECRET;
        const base36 = salted.toString(36);
        const lengthChar = base36.length.toString(36);
        const randomSuffix = this.cryptoRandomString(7);
        const combined = this.shuffleString(lengthChar + base36 + randomSuffix);

        return combined;
    }

    public static decode(coded: string): number {
        const unshuffled = this.unshuffleString(coded);

        const lengthChar = unshuffled[0];
        const base36Length = parseInt(lengthChar, 36);
        const base36Part = unshuffled.slice(1, 1 + base36Length);

        const salted = parseInt(base36Part, 36);
        const original = salted ^ this.SECRET;

        return original;
    }

    private static cryptoRandomString(length: number): string {
        const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);
        return Array.from(array, (x) => chars[x % chars.length]).join('');
    }

    private static shuffleString(input: string): string {
        const arr = input.split('');
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor((i * 31) % arr.length);
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr.join('');
    }

    private static unshuffleString(input: string): string {
        const arr = input.split('');
        for (let i = 0; i < arr.length; i++) {
            const j = Math.floor((i * 31) % arr.length);
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr.join('');
    }
}
